import './selectComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function selectComponent() {
	return {
		bindings: {
			prepend: '<?',
			options: '<',
			append: '<?',
			value: '@',
			text: '@',
			model: '=',
			onChange: '&?',
		},
		controllerAs: 'vm',
		controller: selectComponentCtrl,
		template: '<select></select>',
	};
}

export class selectComponentCtrl {
	constructor($element, $scope) {
		'ngInject';
		this.$scope = $scope;
		this.select = $element.find('select');
		this.select.on('change', this.onUserChange.bind(this));
		this.$scope.$watch('vm.model', this.setFromModel.bind(this));
		this.value = this.value || 'id';
		this.text = this.text || 'name';
	}

	$onChanges = changes => {
		// a change in prepend, options or append
		this.render();
		this.setFromModel();
	};

	onUserChange(event) {
		const oldValue = this.model;
		const idx = this.select[0].selectedIndex;
		if (idx == -1) {
			this.model = undefined;
		} else {
			const prepend = ensure.array(this.prepend);
			const options = ensure.array(this.options);
			const append = ensure.array(this.append);
			let obj = {};
			if (idx >= 0 && idx < prepend.length) {
				obj = prepend[idx];
			} else if (idx >= prepend.length && idx < prepend.length + options.length) {
				obj = options[idx - prepend.length];
			} else if (idx >= prepend.length + options.length && idx < prepend.length + options.length + append.length) {
				obj = append[idx - prepend.length - options.length];
			}
			this.model = obj[this.value];
		}
		this.$scope.$apply();
		this.onChange &&
			this.onChange({
				$event: event,
				$oldValue: oldValue,
				$newValue: this.model,
			});
		this.$scope.$apply();
	}

	render() {
		this.select[0].options.length = 0;
		let idx = 0;
		const addOption = obj => {
			this.select[0].options[idx++] = new Option(obj[this.text], obj[this.value]);
		};
		ensure.array(this.prepend).forEach(addOption);
		ensure.array(this.options).forEach(addOption);
		ensure.array(this.append).forEach(addOption);
	}

	setFromModel() {
		let foundAt;
		let selIdx;
		const prepend = ensure.array(this.prepend);
		const options = ensure.array(this.options);
		const append = ensure.array(this.append);
		const findValue = (obj, idx) => {
			if (this.model === obj[this.value]) {
				foundAt = idx;
				return true;
			}
		};
		if (prepend.some(findValue)) {
			// selIdx is correct; no change needed
			selIdx = foundAt;
		} else if (options.some(findValue)) {
			// selected index is
			selIdx = foundAt + prepend.length;
		} else if (append.some(findValue)) {
			selIdx = foundAt + prepend.length + options.length;
		} else {
			selIdx = -1;
		}
		this.select[0].selectedIndex = selIdx;
	}
}
